import React from 'react';
import TransportERP from './TransportERP';

function App() {
  return <TransportERP />;
}

export default App;
